import { S as Swiper, N as Navigation } from './navigation-DRQRnwd0.js';

class LogoSlider extends HTMLElement {
  connectedCallback() {
    this.navigation = this.querySelector('.swiper-button-prev--logo, .swiper-button-next--logo');
    let sliderNavigation = '';
    if (this.navigation) {
      sliderNavigation = {
        nextEl: '.swiper-button-next--logo',
        prevEl: '.swiper-button-prev--logo',
      };
    }

    this.initSwiper(sliderNavigation);
  }

  initSwiper(sliderNavigation) {
    new Swiper(this.querySelector('.swiper--logo'), {
      modules: [Navigation],
      slidesPerView: 2.5,
      centeredSlides: false,
      breakpoints: {
        768: {
          slidesPerView: 4,
        },
      },
      navigation: sliderNavigation,
      spaceBetween: 16,
    });
  }
}

customElements.define('logo-slider', LogoSlider);
